/**
 * URL Helper to generate public, cross-device accessible pairing links
 * across Web, Capacitor Android, and Chrome extensions.
 */

export function getPublicWebOrigin(): string {
  if (typeof window !== 'undefined') {
    const isCapacitor =
      typeof (window as any).Capacitor !== 'undefined' &&
      typeof (window as any).Capacitor.isNativePlatform === 'function' &&
      (window as any).Capacitor.isNativePlatform();

    const host = window.location.hostname;
    const isLocal =
      host === 'localhost' ||
      host === '127.0.0.1' ||
      host.endsWith('.local') ||
      window.location.protocol === 'capacitor:' ||
      window.location.protocol === 'file:';

    // If running on a deployed public domain (e.g. Cloudflare Pages or custom domain)
    if (!isCapacitor && !isLocal && window.location.origin.startsWith('http')) {
      return window.location.origin;
    }
  }

  // Default production website URL
  return 'https://ck-share.pages.dev';
}

export function getAppInviteUrl(roomId: string, accessCode: string): string {
  const base = getPublicWebOrigin();
  return `${base}/?room=${encodeURIComponent(roomId.trim().toUpperCase())}&key=${encodeURIComponent(accessCode.trim())}`;
}
